import { jwtDecode } from 'jwt-decode';

export function isLiveJwt(jwt: string): boolean {
  try {
    const decodedToken = getToken<{ exp: number }>(jwt);

    if (!decodedToken?.exp) {
      return false;
    }

    //has it expired
    const expiry = new Date(0);
    expiry.setUTCSeconds(decodedToken.exp);

    return expiry > new Date();
  } catch (error) {
    return false;
  }
}

export function getToken<Payload>(jwt: string): Payload | undefined {
  try {
    return jwtDecode<Payload>(jwt);
  } catch (error) {
    return undefined;
  }
}
